import { Save } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { cn } from '@/shared/lib/utils';

import { AsyncActionButton } from '../async-action-button';

export interface SaveButtonProps {
  onClick: () => void;
  hasChanges: boolean;
  isSaving: boolean;
  changeCount?: number;
  className?: string;
  disabled?: boolean;
}

export function SaveButton({
  onClick,
  hasChanges,
  isSaving,
  changeCount,
  className,
  disabled,
}: SaveButtonProps) {
  const { t } = useTranslation('sharedUi');
  const idleClassName = cn(
    hasChanges
      ? 'border-phx-draft! text-phx-draft-text! bg-phx-draft-tint! hover:bg-phx-draft-tint/90!'
      : 'border-phx-border-2 text-phx-text-muted hover:text-phx-text hover:border-phx-border-3',
    'disabled:cursor-not-allowed disabled:opacity-50',
    className
  );

  return (
    <AsyncActionButton
      isRunning={isSaving}
      onClick={onClick}
      runningLabel={t('saveButton.saving')}
      doneLabel={t('saveButton.saved')}
      className={idleClassName}
      disabled={disabled}
    >
      <Save className="h-3.5 w-3.5" aria-hidden="true" />
      {t('saveButton.save')}
      {changeCount != null && changeCount > 0 ? (
        <span
          aria-hidden
          className="bg-phx-draft ml-0.5 inline-flex h-[1.1rem] min-w-[1.1rem] items-center justify-center rounded-full px-0.5 text-[10px] leading-none font-bold text-white"
        >
          {changeCount > 99 ? '99+' : changeCount}
        </span>
      ) : null}
    </AsyncActionButton>
  );
}
